import { Box } from '@mui/material';
import { DefaultLayout } from '@/layouts';
import { useFetchCookies } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';
import { EsSheetContainer } from '@/components/EsSheet/EsSheetContainer';
import { StructureCheck } from '@/components/shared/StructureCheck';
import { useRouter } from '@/hooks';
import { AccessGuard } from '@/components/Analysis/shared/AccessGuard';

export const EsSheetPage = () => {
  const cookiesFetched = useFetchCookies();
  const router = useRouter();
  const { platformId } = router.query;

  if (!platformId || Array.isArray(platformId)) {
    return <div>Please specify platform id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <StructureCheck structureId={platformId}>
      <AccessGuard structureId={platformId} feature="riskAssessment">
        <DefaultLayout>
          <EsSheetContainer platformId={platformId} />
        </DefaultLayout>
      </AccessGuard>
    </StructureCheck>
  );
};
